import React, { useState, useEffect } from "react";

import tableIcons from "../../config/tableIcons";
import MaterialTable from "material-table";

const List = ({ columns, rows, getRows, actions, pagination = true }) => {
    const [data, setData] = useState({
        loading: false,
        rows: rows,
        columns: columns,
        totalRows: rows.length,
        rowsPerPageOptions: [10, 30, 50, 100],
        pageSize: 100,
        page: 0,
    });

    const updateData = (k, v) => setData((prev) => ({ ...prev, [k]: v }));

    const fetchData = (page, pageSize) => {
        updateData("loading", true);
        if (typeof getRows === "function") {
            getRows(page + 1, pageSize)
                .then((resp) => {
                    if (resp) {
                        updateData("rows", resp.rows || resp);
                        updateData("totalRows", resp.total || resp.length || 0);
                    }
                })
                .finally(() => {
                    updateData("loading", false);
                });
        } else {
            updateData("rows", getRows);
            updateData("totalRows", 0);
            updateData("loading", false);
        }
    };

    useEffect(() => {
        fetchData(data.page, data.pageSize);
    }, []);

    return (
        <>
            <MaterialTable
                icons={tableIcons}
                isLoading={data.loading}
                data={data.rows}
                columns={data.columns}
                actions={actions}
                options={{
                    pageSize: data.pageSize,
                    pageSizeOptions: data.rowsPerPageOptions,
                    // search: false,
                    showTitle: false,
                    totalCount: data.totalRows,
                }}
                onChangeRowsPerPage={(newPageSize) => {
                    updateData("pageSize", newPageSize);
                    updateData("page", 0);
                    fetchData(0, newPageSize);
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: "Nenhum registro para exibir",
                    },
                    toolbar: {
                        searchTooltip: "Pesquisar",
                        searchPlaceholder: "Pesquisar",
                    },
                    pagination: {
                        labelRowsSelect: "linhas",
                        labelDisplayedRows: "{count} de {from}-{to}",
                        firstTooltip: "Primeira página",
                        previousTooltip: "Página anterior",
                        nextTooltip: "Próxima página",
                        lastTooltip: "Última página",
                    },
                    header: {
                        actions: "Ações",
                    },
                }}
                style={{ maxWidth: "90vw", overflow: "auto", minWidth: "80vw" }}
            />
        </>
    );
};

export default List;
